import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/projects/actions.projects';
import noScriptImgDev from '../../../../assets/images/project/no-scripts-pic-dev@2x.png';
import noScriptImgTest from '../../../../assets/images/project/no-scripts-pic-test@2x.png';
import noScriptImgProd from '../../../../assets/images/project/no-scripts-pic-prod@2x.png';
import {Environment} from '../../../../const/environment';
import environmentNames from '../../../../const/environmentNames';
import createNewScriptHelper from '../../../../services/actionHelpers/createNewScriptHelper';
import NoContentView from '../../../components/NoContentView/NoContentView';

const images = {
    [Environment.Staging]: noScriptImgDev,
    [Environment.Testing]: noScriptImgTest,
    [Environment.Production]: noScriptImgProd,
};

class NoScriptsView extends React.Component {

    createNewScript = () => {
        const { project, createScript } = this.props;
        createNewScriptHelper(project, createScript);
    }

    render() {
        const { environment } = this.props;
        return <NoContentView
            img={images[environment]}
            label=""
            environment={environment}
            action={environment === Environment.Staging && this.createNewScript}
            btnLabel="Add Script" />;
    }
}

function mapStateToProps({ projectsInfo }, ownProps) {
    return {
        project: projectsInfo.currentProject
    };
}

function mapDispatchToProps(dispatch) {
    return {
        createScript: (param) => dispatch(actions.createScript(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NoScriptsView);